import Input from './input';
import InputGroup from './input-group';
import InputGroupAddon from './input-group-addon';
var DefaultInput = Input;
DefaultInput.Group = InputGroup;
DefaultInput.Addon = InputGroupAddon;
export default DefaultInput;
//# sourceMappingURL=index.js.map